<div class="info-section">
  <div class="info-value" *ngFor="let info of popupInfo">
    <ng-container [ngTemplateOutlet]="info.template ? info.template : defaultTemplate" [ngTemplateOutletContext]="{ data: info }" />
  </div>
  <div class="info-value">
    <div class="edit-icons-container">
      <mat-icon class="edit-icon" svgIcon="edit-16" *ngIf="!isEditing" (click)="isEditing = true" matTooltip="Edit note"></mat-icon>
      <mat-icon class="undo-icon" fontIcon="undo" *ngIf="isEditing" (click)="undoNoteEdit()" matTooltip="Cancel"></mat-icon>
      <mat-icon class="save-icon" fontIcon="save" *ngIf="isEditing" (click)="saveNoteEdit()" matTooltip="Save"></mat-icon>
    </div>
    <dx-text-area
      #textArea
      [value]="instance.comment"
      label="note"
      labelMode="outside"
      [readOnly]="!isEditing"
      stylingMode="outlined"
      [elementAttr]="{
        class: 'value-note'
      }"
    ></dx-text-area>
  </div>
</div>
<ng-template #demoComposition let-data="data">
  <div class="label">{{ data.label }}</div>
  <div class="value">{{ data.value }} <mat-icon svgIcon="info-16" [id]="data.id"></mat-icon></div>
  <dx-popover
    [target]="'#' + data.id"
    showEvent="mouseenter"
    hideEvent="mouseleave"
    position="right"
    [wrapperAttr]="{ class: 'demo-composition-popover' }"
  >
    <div *dxTemplate="let data = model of 'content'">
      <strong class="title">Demos Included</strong>
      <ul>
        <li *ngFor="let asset of instance.relatedAssets">{{ asset }}</li>
      </ul>
    </div>
  </dx-popover>
</ng-template>
<ng-template #defaultTemplate let-data="data">
  <div class="label">{{ data.label }}</div>
  <div class="value">{{ data.value }}</div>
</ng-template>
